"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CirrusTimeoutError = exports.CirrusError = void 0;
class CirrusError extends Error {
    constructor(message, request, response) {
        super(message);
        this.request = request;
        this.response = response;
    }
}
exports.CirrusError = CirrusError;
class CirrusTimeoutError extends Error {
    constructor(message, request) {
        super(message);
        this.request = request;
    }
}
exports.CirrusTimeoutError = CirrusTimeoutError;
//# sourceMappingURL=errors.js.map